<template>
  <b-row class="justify-content-md-center m-0">
    <b-col lg="6">
      <div v-if="isVideoConferencePost">
        <EditVideoConference />
      </div>
      <div v-else>
        <CreateOrEditPost />
        <!-- :learningUnitId="learningUnitId" -->
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { learningUnitInfoMixin } from '@/mixins';
import { CreateOrEditPost, EditVideoConference } from './components';

export default {
  name: 'PageManagePost',

  components: {
    CreateOrEditPost,
    EditVideoConference
  },

  mixins: [learningUnitInfoMixin],

  computed: {
    isVideoConferencePost() {
      return this.$route.name === 'design-planning/post/edit-video-conference';
    }
  }
};
</script>

<style lang="scss" scoped></style>
